import { render, staticRenderFns } from "./ReturnGoodsDetail.vue?vue&type=template&id=967910fc&scoped=true&"
import script from "./ReturnGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./ReturnGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReturnGoodsDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReturnGoodsDetail.vue?vue&type=style&index=1&id=967910fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967910fc",
  null
  
)

export default component.exports